import React from 'react';
import { bool, shape, string } from 'prop-types';

const AgroOperationColor = ({
  className = '',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.25 4.32823C3.8775 5.42323 3 7.11073 3 9.00073C3 12.0532 5.295 14.5807 8.25 14.9482V16.4632C4.4625 16.0882 1.5 12.8932 1.5 9.00073C1.5 6.75823 2.49 4.74823 4.05 3.37573H2.25V1.87573H6.75V5.62573H5.25V4.32823Z" fill="currentColor" />
    <path d="M15 9.00073C15 10.8907 14.1225 12.5707 12.75 13.6732V12.3757H11.25V16.1257H15.75V14.6257H13.95C15.51 13.2532 16.5 11.2432 16.5 9.00073H15Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.5244 2.46392C15.6761 2.61228 15.7579 2.81795 15.7494 3.02998C15.6711 4.99617 15.3318 7.39035 14.0337 9.02465L14.0304 9.02876C12.874 10.464 11.227 10.9976 9.75 11.1833V14.2501H8.25V12.6732C7.35518 12.5304 6.36706 12.1756 5.6465 11.3172L5.64312 11.3131C4.76327 10.2496 4.54998 8.72069 4.50065 7.53122C4.49186 7.31932 4.57319 7.1136 4.72452 6.965C4.87585 6.81641 5.08301 6.73883 5.29472 6.75147C6.29608 6.81128 7.58578 7.06978 8.49917 8.06433C8.73506 6.76497 9.17051 5.47751 9.96627 4.47563L9.96956 4.47152C11.3139 2.80315 13.321 2.35315 14.9534 2.25159C15.1652 2.23841 15.3727 2.31556 15.5244 2.46392ZM11.1392 5.41062C10.3107 6.45518 9.94209 8.02683 9.80291 9.66158C10.9856 9.47852 12.096 9.03749 12.8608 8.08964C13.6893 7.04508 14.0579 5.47344 14.1971 3.8387C13.0144 4.02176 11.9041 4.46278 11.1392 5.41062ZM8.17444 11.1311C8.06715 10.3342 7.84862 9.62507 7.45286 9.14546C7.10967 8.73769 6.6281 8.49897 6.07556 8.36916C6.18285 9.16603 6.40138 9.87521 6.79715 10.3548C7.14034 10.7626 7.6219 11.0013 8.17444 11.1311Z" fill="currentColor" />
  </svg>
);

AgroOperationColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default AgroOperationColor;
